// Recovered compiled webpack factory 62592. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "createInitialRouterState", {
      enumerable: !0,
      get: function () {
        return c;
      },
    }));
  let n = r(29658),
    a = r(30637),
    o = r(86343),
    i = r(83571),
    s = r(86871),
    l = r(23597),
    u = r(16378);
  function c(e) {
    var t, r;
    let {
        navigatedAt: c,
        initialFlightData: f,
        initialCanonicalUrlParts: d,
        initialParallelRoutes: p,
        location: h,
        couldBeIntercepted: _,
        postponed: m,
        prerendered: g,
      } = e,
      y = d.join("/"),
      v = (0, u.getFlightDataPartsFromPath)(f[0]),
      { tree: b, seedData: E, head: R } = v,
      P = {
        lazyData: null,
        rsc: null == E ? void 0 : E[1],
        prefetchRsc: null,
        head: null,
        prefetchHead: null,
        parallelRoutes: p,
        loading: null != (t = null == E ? void 0 : E[3]) ? t : null,
        navigatedAt: c,
      },
      S = h ? (0, n.createHrefFromUrl)(h) : y;
    (0, l.addRefreshMarkerToActiveParallelSegments)(b, S);
    let O = new Map();
    (null === p || 0 === p.size) &&
      (0, a.fillLazyItemsTillLeafWithHead)(c, P, void 0, b, E, R, void 0);
    let T = {
      tree: b,
      cache: P,
      prefetchCache: O,
      pushRef: { pendingPush: !1, mpaNavigation: !1, preserveCustomHistoryState: !0 },
      focusAndScrollRef: { apply: !1, onlyHashChange: !1, hashFragment: null, segmentPaths: [] },
      canonicalUrl: S,
      nextUrl:
        null !=
        (r = (0, o.extractPathFromFlightRouterState)(b) || (null == h ? void 0 : h.pathname))
          ? r
          : null,
    };
    if (h) {
      let e = new URL("" + h.pathname + h.search, h.origin);
      (0, i.createSeededPrefetchCacheEntry)({
        url: e,
        data: {
          flightData: [v],
          canonicalUrl: void 0,
          couldBeIntercepted: !!_,
          prerendered: g,
          postponed: m,
          staleTime: g && 1 ? i.STATIC_STALETIME_MS : -1,
        },
        tree: T.tree,
        prefetchCache: T.prefetchCache,
        nextUrl: T.nextUrl,
        kind: g ? s.PrefetchKind.FULL : s.PrefetchKind.AUTO,
      });
    }
    return T;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
